import { useNavigate } from '@fukuri-admins/hooks/common';
import {
  ChartLineIcon,
  HouseIcon,
  MailPlusIcon,
  NotepadTextIcon,
  StoreIcon,
} from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import styles from './styles.module.scss';

type MenuItem = {
  img: string;
  content: string;
  link: string;
  isExternal: boolean;
};

const Image = ({ img, alt }: { img: string; alt: string }) => {
  const iconProps = {
    className: 'styles.BottomNavMenu__Icon',
    alt,
  };
  const map = {
    house: <HouseIcon {...iconProps} />,
    notepadText: <NotepadTextIcon {...iconProps} />,
    chartLine: <ChartLineIcon {...iconProps} />,
    store: <StoreIcon {...iconProps} />,
    mailPlus: <MailPlusIcon {...iconProps} />,
  };
  return map[img];
};

type Props = {
  menus: MenuItem[];
};

export const BottomNavMenu: React.FC<Props> = ({ menus }) => {
  const navigate = useNavigate();

  return (
    <nav className={styles.BottomNavMenu}>
      {menus.map(menu => (
        <button
          key={menu.link}
          className={clsx(styles.BottomNavMenu__Item, {
            [styles.active]: location.pathname === menu.link,
          })}
          onClick={() => {
            if (menu.isExternal) {
              window.open(menu.link, '_blank');
            } else {
              navigate(menu.link);
            }
          }}
        >
          <Image img={menu.img} alt={menu.content} />
          <span className={styles.BottomNavMenu__Label}>{menu.content}</span>
        </button>
      ))}
    </nav>
  );
};
